import { isNumeric } from '../../util/helpers';
import { ReviewInteractions } from './review-interactions.model';
import { ReviewSubrating } from './review-subrating.model';
import { Photo } from './photo.model';
import { NgxGalleryImage } from 'ngx-gallery';


/**
 * Base review/rating model
 */
export class Review {
  /**
   * Unique identifier for this record in the database
   */
  id: number;

  /**
   * Source ID that identifies the source of this data (e.g., airport manager)
   */
  sourceId: number;

  /**
   * Numeric ID of the user who left the review
   */
  userId: number;

  /**
   * Review text
   */
  review: string;

  /**
   * Numeric rating
   */
  rating: number;

  /**
   * Date the review was added
   */
  addDate: Date;

  /**
   * Date the review was modified
   */
  modDate: Date;

  /**
   * Name of the user who left the review
   */
  userName: string;

  /**
   * Title of the review
   */
  title: string;

  /**
   * Entity manager's response to review
   */
  response: string;

  /**
   * Entity manager's response to review
   */
  responseDate: Date;

  /**
   * Entity manager's response to review
   */
  responseOper: string;

  /**
   * Boolean to track if this review should be displayed in full if it is long
   */
  displayFull: boolean;

  /**
   * Boolean to track if this review response should be displayed in full if it is long
   */
  responseDisplayFull: boolean;

  /**
   * Object containing the various interactions for this review
   */
  interactions: ReviewInteractions;

  /**
   * Object containing the various subratings given by the user in this review
   */
  subRatings: Array<ReviewSubrating>;

  /**
   * Array containing any photos associated with this review
   */
  photos: Array<Photo>;

  /**
   * Array containing any photos associated with this review
   */
  galleryPhotos: Array<NgxGalleryImage>;

  /**
   * Parses review
   * @param data {any} Review data as returned by API
   * @return {Review} Parsed review
   */
  static parse(data: any): Review {
    return {
      id: data.reviewId,
      sourceId: data.sourceId,
      userId: data.recid,
      review: data.review,
      rating: isNumeric(data.rating) ? +data.rating : null,
      addDate: data.addDate ? new Date(data.addDate) : null,
      modDate: data.modDate ? new Date(data.modDate) : null,
      userName: data.addOper,
      title: data.title,
      response: data.response,
      responseDate: data.responseDate ? new Date(data.responseDate) : null,
      responseOper: data.responseOper,
      displayFull: false,
      responseDisplayFull: false,
      interactions: data.interactions ? ReviewInteractions.parse(data.interactions) : null,
      subRatings: (data.subRatings || []).map(d => ReviewSubrating.parse(d)),
      photos: (data.photos || []).map(d => Photo.parse(d)),
      galleryPhotos: (data.photos || []).map(d => {
        return {
          big: d.largePhotoPath,
          medium: d.previewPhotoPath,
          small: d.thumbnailPhotoPath
        };
      })
    };
  }
}
